
import Catagories from "../directory/Catagories";
const Home = ()=> {
  
  return (
    <div>
      <Catagories />
    </div>
      
  );
}

export default Home;
